import PhoneIcon from "../assets/svg/phone.svg";
import EmailIcon from "../assets/svg/email.svg";
import LocationIcon from "../assets/svg/location.svg";

const contacts = [
  {
    icon: PhoneIcon,
    title: "Phone",
    info: "(+63) 9772181373",
  },
  {
    icon: EmailIcon,
    title: "Email",
    info: "khaizter.vashh@gmail.com",
  },
  {
    icon: LocationIcon,
    title: "Location",
    info: "Cavite, Philippines",
  },
];

export default contacts;
